// containers/Main/Main.js
import React, { useEffect, useState } from 'react';
import WelcomeModal from '../../components/Onboarding/WelcomeModal';
import Tour from '../../components/Onboarding/Tour';
import GettingStarted from '../../components/Onboarding/GettingStarted';
import { useOnboarding } from '../../components/Onboarding/OnboardingProvider';

export const Main = ({ children }) => {
  const { welcomeSeen } = useOnboarding();
  const [welcomeOpen, setWelcomeOpen] = useState(false);

  // First login: show the welcome modal once (any authenticated /profile page).
  useEffect(() => {
    if (!welcomeSeen && localStorage.getItem('authenticated') === 'true') {
      setWelcomeOpen(true);
    }
  }, [welcomeSeen]);

  return (
    <div>
      {children}
      <WelcomeModal open={welcomeOpen} onClose={() => setWelcomeOpen(false)} />
      <Tour />
      <GettingStarted />
    </div>
  );
};

export default Main;
